<template>
  <div>
    <div class="card process p-4" v-if="parser?.id">
      <div class="title">
        <div class="wrap">
          <h5><i class="bi bi-check-circle"></i> Сбор данных завершён!</h5> <br>
          <div class="sub-title">Режим: <span v-for="type in parser.types">{{ type_names[type] }}&nbsp;</span>
          </div>
        </div>
        <div class="ms-auto">
          <h4>{{ parser.status?.all - parser?.status?.not_ready }} / {{ parser.status?.all }}</h4> <br>
          <div class="help-text">ссылок обработано</div>
        </div>
      </div>
      <div class="progress" role="progressbar" :aria-valuenow="100" aria-valuemin="0"
           aria-valuemax="100">
        <div class="progress-bar" style="width: 100%">100%</div>
      </div>
      <div class="line mt-2">
        <span>Начато: <span
            v-if="parser.date_start">{{ $moment(parser.date_start).format('DD.MM.YYYY HH:mm') }}</span></span>
        <span>Завершено: <span
            v-if="parser.date_end">{{ $moment(parser.date_end).format('DD.MM.YYYY HH:mm') }}</span></span>

      </div>

    </div>
    <div class="card p-4">
      <h6><b>Результаты сбора</b></h6>
      <div class="groups">
        <div class="group">
          <div class="value">{{ stat.reviews }}</div>
          <div class="help-text">Отзывов собрано</div>
        </div>
        <div class="group">
          <div class="value text-primary">{{stat.links}}</div>
          <div class="help-text">Ссылок успешно</div>
        </div>
        <div class="group">
          <div class="value text-danger">{{ stat.errors }}</div>
          <div class="help-text">Ошибок</div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>

import {ParserApi} from "@/api/parser";

export default {
  name: 'ParserResult',
  props: {
    parser: {type: Object}
  },
  data() {
    return {
      stat: {},
      type_names: {
        review: "Сбор отзывов",
        rating: "Сбор оценок"
      }
    }
  },
  watch: {},
  mounted: function () {

    ParserApi.get_stat(this.parser.id).then(response=>this.stat=response)

  },
  computed: {},

  methods: {}
}

</script>
<style scoped lang="scss">

.process {
  .ms-auto {
    text-align: right;
  }

  .sub-title, .help-text {
    color: #ffffff;
  }

  color: #fff;
  background: linear-gradient(90deg, rgba(34, 196, 94, 1) 0%, rgba(29, 182, 85, 1) 50%, rgba(22, 163, 74, 1) 100%);

  .progress {
    height: 25px;
    border-radius: 13px;
    background-color: var(--light-blue);

    .progress-bar {
      background-color: var(--white) !important;
      color: var(--green);
      border-radius: 13px;
    }
  }
}
.groups{
  display: flex;
  justify-content: space-around;
  .group {
    text-align: center;
    .value {
      font-size: 40px;
      font-weight: bold;
      color: var(--green);
    }

    .help-text {
      font-size: 14px;
      color: var(--dark-grey);
    }
  }
}

@media (width < 768px) {
        .title{
    background: transparent!important;
  }

}

</style>

